import fetch from '@strictsoftware/fetch';
import { isLeadVentaVehiculoOcasionForm } from '../../../helpers/form-helpers';
import { DataHorariosCallMe } from '../../../types/call-me-types';
import { DataDealer } from '../../../types/dealer-types';
import { Carline, CarlineWithModels, CarlineWithSalesgroups } from '../../../types/vehicle-types';
import { configProviderManager } from '../../config-provider';

const cache = new Map<string, Promise<any>>();

export const fetchData = (path: string): Promise<any | null> => {
	const url = `${configProviderManager.getDataUrl()}/${path}`;

	if (cache.has(url)) return cache.get(url)!;

	const promise = fetch(url)
		.then((res) => res.json())
		.catch(() => null);

	cache.set(url, promise);
	return promise;
};

export const fetchCarlines = async (): Promise<Carline[] | null> => {
	try {
		const path = isLeadVentaVehiculoOcasionForm() ? 'getVOCarlines' : 'getCarlines';
		const data = await fetchData(path);
		return data?.carlines || null;
	} catch (error) {
		return null;
	}
};

export const fetchCarlinesWithSalesgroups = async (): Promise<CarlineWithSalesgroups[] | null> => {
	try {
		const path = isLeadVentaVehiculoOcasionForm() ? 'getSalesgroups/true' : 'getSalesgroups';
		const data = await fetchData(path);
		return data?.carlines || null;
	} catch (error) {
		return null;
	}
};

export const fetchCarlinesWithModels = async (): Promise<CarlineWithModels[] | null> => {
	try {
		const path = 'getModels';
		const data = await fetchData(path);
		return data?.carlines || null;
	} catch (error) {
		return null;
	}
};

export const fetchDataOfertas = async (): Promise<any | null> => {
	try {
		const path = 'v2/getOfertas';
		const data = await fetchData(path);
		return data?.carlines || null;
	} catch (error) {
		return null;
	}
};

export const fetchDataPreconfiguraciones = async (): Promise<CarlineWithSalesgroups[] | null> => {
	try {
		const path = 'getPreconfiguraciones';
		const data = await fetchData(path);
		return data?.carlines || null;
	} catch (error) {
		return null;
	}
};

export const fetchDataDealers = async (): Promise<DataDealer[] | null> => {
	try {
		const path = 'getDealers';
		const data = await fetchData(path);
		return data?.dealers || null;
	} catch (error) {
		return null;
	}
};

export const fetchHorariosCallMe = async (): Promise<DataHorariosCallMe | null> => {
	try {
		const path = 'getHorariosCallMeNow';
		const data = await fetchData(path);
		return data?.horarios || null;
	} catch (error) {
		return null;
	}
};
